import React, {Component} from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';

//CSS
import '../../LandingSubcomponents/Servicios.css';

class Entregas extends Component {
    render() {

        return (
            <Row className="entregas width450">
                <Col md={6} sm={12} xs={12} className="entregas-seccion-izquierda">
                    <Row>
                        <Col md={7} sm={12} xs={12}
                             className="entregas-descripcion wow animated bounceInLeft" data-wow-duration="1s">
                            <h3>
                                Entregas en toda la región
                            </h3>
                            <h4>
                                Realizamos la distribución de tus pedidos en toda la región. Ingresá a nuestro
                                carrito de compras On-Line y convertite en un cliente más que confía en nosotros.
                            </h4>
                            <a href="http://carrito.myfdistribuciones.com.ar/sk2.myf/registro.php" target="_blank">
                                <Button className="btn-primary">
                                    Registrate
                                </Button>
                            </a>
                        </Col>
                    </Row>
                </Col>
                <Col md={6} smHidden xsHidden className="entregas-seccion-derecha">

                </Col>
            </Row>
        );
    }
}


export default Entregas;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Servicios/Entregas.js